"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LoadingState = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsx)("div", { className: "fixed inset-0 flex items-center justify-center blur-background transition-opacity duration-500 ".concat(isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'), style: { zIndex: 1001 }, children: (0, jsx_runtime_1.jsx)("div", { className: "relative flex justify-center items-center", children: (0, jsx_runtime_1.jsx)("div", { className: "absolute animate-spin w-16 h-16 border-4 border-gray-300 border-t-4 border-t-white rounded-full" }) }) }));
};
exports.default = LoadingState;
